/**
 * Шлём события только с боевого адреса. Одной проверки production-сборки мало: локальная сборка для приёмки на
 * `*.localhost` писала в боевые Метрику, Amplitude и GA (2026-11-04).
 */
export function analyticsEnabled(): boolean {
  return import.meta.env.PROD && typeof window !== 'undefined' && /(^|\.)lomora\.ru$/.test(window.location.hostname);
}
